export default {
  path: 'products',
  name: 'product',
};
